import { render, staticRenderFns } from "./TableImproveHistory.vue?vue&type=template&id=7e471f1e&scoped=true&"
import script from "./TableImproveHistory.vue?vue&type=script&lang=js&"
export * from "./TableImproveHistory.vue?vue&type=script&lang=js&"
import style0 from "./TableImproveHistory.vue?vue&type=style&index=0&id=7e471f1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e471f1e",
  null
  
)

export default component.exports